import { publicClient, privateClient } from './client';
import { V2UrlResource } from './V2UrlResource';

const queryV2UrlResource = (pub: boolean) => new V2UrlResource(pub ? publicClient : privateClient);
export default queryV2UrlResource;
